<div class="divHome">
  <div style="padding-bottom: 2rem">
      <h2>Ordenes de Compra</h2>
  </div>
  <hr style="margin-bottom: 2rem">

  <div *ngIf="loading" class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>

  <div *ngIf="!loading" style="display: flex; justify-content: center;">
    <mat-form-field appearance="outline" class="buttonFilter">
      <mat-label>TIPO DE PROVEEDOR</mat-label>
      <mat-select [(value)]="selectTipoProveedor" (selectionChange)="applyFilterSelect()">
        <mat-option value={{null}}>No seleccionar</mat-option>
        <mat-option *ngFor="let tipoProveedor of arrayTipoProveedor" value={{tipoProveedor}}>{{tipoProveedor}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="divInputSearch" style="width: 70%">
      <mat-label>Filtrar</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda" />
    </mat-form-field>

  </div>
  <br>

  <div [style.display]="loading ? 'none' : 'block'" class="example-container mat-elevation-z8 overflow"  *ngIf="DataSource">
    <mat-table    [dataSource]="DataSource" matSort >

      <mat-header-row *matHeaderRowDef="DisplayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: DisplayedColumns"></mat-row>

      <ng-container matColumnDef="codigoOC">
          <mat-header-cell *matHeaderCellDef>Codigo</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.codigoOC }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="nameProvider">
        <mat-header-cell *matHeaderCellDef>Proveedor</mat-header-cell>
        <mat-cell *matCellDef="let element; let i=index">{{ element.nameProvider }}
          <button mat-icon-button style="  color: #e95a1a" (click)="openDialogProvider(element, i)"><mat-icon style="color: '#36b036'">edit</mat-icon></button>
             </mat-cell>
    </ng-container>

      <ng-container matColumnDef="rucProvider">
          <mat-header-cell *matHeaderCellDef>RUC</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.rucProvider }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="tipoProvider">
        <mat-header-cell *matHeaderCellDef>TIPO</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.tipoProvider }}</mat-cell>
    </ng-container>

      <ng-container matColumnDef="area">
          <mat-header-cell *matHeaderCellDef>Area</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.area }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="descripcionCC">
        <mat-header-cell *matHeaderCellDef>Centro de Costo</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.descripcionCC }}</mat-cell>
    </ng-container>

      <ng-container matColumnDef="moneda">
          <mat-header-cell *matHeaderCellDef>Moneda</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.moneda }}</mat-cell>
      </ng-container>

    <ng-container matColumnDef="subTotal">
      <mat-header-cell *matHeaderCellDef>subTotal</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.subTotal }}</mat-cell>
  </ng-container>

    <ng-container matColumnDef="igv">
        <mat-header-cell *matHeaderCellDef>igv</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.igv }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="items">
      <mat-header-cell *matHeaderCellDef>items</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.items ? element.items.length : 0 }} <button mat-icon-button (click)="openDialogItems(element)"><mat-icon class="icon-color">
        pinch_zoom_out</mat-icon></button></mat-cell>
  </ng-container>

    <ng-container matColumnDef="total">
      <mat-header-cell *matHeaderCellDef>total</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.total }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="pagos">
    <mat-header-cell *matHeaderCellDef>Pagos</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.lstRegCompras ? element.lstRegCompras.length : 0 }} <button mat-icon-button (click)="openDialogPagos(element)"><mat-icon class="icon-color">
      pinch_zoom_out</mat-icon></button></mat-cell>
</ng-container>

  <ng-container matColumnDef="saldoSubTotal">
    <mat-header-cell *matHeaderCellDef>saldo SubTotal</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.saldoSubTotal }}</mat-cell>
</ng-container>

  <ng-container matColumnDef="saldoIgv">
      <mat-header-cell *matHeaderCellDef>saldo Igv</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.saldoIgv }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="saldoTotal">
    <mat-header-cell *matHeaderCellDef>saldo Total</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.saldoTotal }}</mat-cell>
</ng-container>

 <!--    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef>Seleccionar</mat-header-cell>
      <mat-cell *matCellDef="let element; let i=index">
        <button mat-icon-button (click)="goBack(element)"><mat-icon class="icon-color">
          send</mat-icon></button>
      </mat-cell>
  </ng-container> -->

    </mat-table>
  </div>
  <div [hidden]="loading">
    <mat-paginator style="width: 100%" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>
  </div>


</div>
